export default "__VITE_ASSET__B$$u60Jk__"